import { MAINTENANCE_FORCED } from "../config";

/**
 * Režim održavanja ima dva nezavisna izvora:
 *  1. env `REACT_APP_MAINTENANCE` — trajno stanje, menja se samo novim buildom;
 *  2. `/maintenance.json` na hostingu — prekidač za hitne slučajeve, menja se
 *     bez builda (izmena fajla u app/build/ + deploy hostinga).
 * Fetch je fail-open: pad mreže ili keširan CDN ne smeju da obore sajt.
 */

export const DEFAULT_TITLE = "Sajt je privremeno nedostupan";
export const DEFAULT_MESSAGE =
    "Radimo na sistemu prodaje karata. Sajt će uskoro biti dostupan — hvala na strpljenju.";

// Stranice koje moraju da rade i tokom održavanja: prodavnice proveravaju pravne
// linkove, a kupac mora da može da zatraži brisanje naloga i nađe kontakt podrške.
export const MAINTENANCE_ALLOWLIST = [
    "/politika-privatnosti",
    "/uslovi-kupovine",
    "/brisanje-naloga",
    "/pomoc",
    // Digitalna kopija karte — putnik na peronu mora da stigne do svog koda
    // i tokom održavanja sajta.
    "/k/",
];

export function isAllowedDuringMaintenance(pathname) {
    return MAINTENANCE_ALLOWLIST.some((p) => pathname.startsWith(p));
}

export async function fetchMaintenanceState() {
    if (MAINTENANCE_FORCED) {
        return { enabled: true, title: DEFAULT_TITLE, message: DEFAULT_MESSAGE };
    }
    try {
        const res = await fetch(`/maintenance.json?t=${Date.now()}`, { cache: "no-store" });
        if (!res.ok) return { enabled: false };
        const cfg = await res.json();
        if (cfg?.enabled !== true) return { enabled: false };
        return {
            enabled: true,
            title: typeof cfg.title === "string" && cfg.title ? cfg.title : DEFAULT_TITLE,
            message: typeof cfg.message === "string" && cfg.message ? cfg.message : DEFAULT_MESSAGE,
        };
    } catch {
        return { enabled: false };
    }
}
